import { renderTableTitle } from "@/utils/render.jsx";
import exportExcel from "@/utils/export-execel";
import dayjs from "dayjs";
export default {
  data() {
    const h = this.$createElement;
    return {
      options2: {
        shortcuts: [{
          text: $t("lg2k93", "近一周"),
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          }
        }, {
          text: $t("igtpkd4", "近一个月"),
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          }
        }, {
          text: $t("igtw8m4", "近三个月"),
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          }
        }]
      },
      visible: false,
      config: {
        map: {
          dataPath: "data.retVal.datas",
          totalPath: "data.retVal.totalRows",
          message: "msg"
        },
        toolBarActions: ["refresh", "fullscreen", "rowSetting"],
        format: {
          formatCurrent: "(page.current - 1) * page.pageSize"
        },
        request: "/api/file/history/page",
        search: {
          searchLableWidth: "200",
          searchLineNum: "2",
          value: {
            startDate: "",
            endDate: ""
          }
        },
        columns: [{
          title: $t("q98bk56", "导入文件名称"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          width: 200,
          key: "fileName",
          notShowForm: true,
          notShowSearch: true
        }, {
          title: $t("by3bzb4", "导入时间"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          width: 200,
          key: "uploadDate",
          notShowForm: true,
          notShowSearch: false,
          renderSearch: ({
            value,
            input
          }) => {
            return h("DatePicker", {
              "ref": "datePicker",
              "attrs": {
                "value": value,
                "options": this.options2,
                "type": "daterange",
                "placeholder": $t("il014u4", "选择时间")
              },
              "on": {
                "input": pre => {
                  if (pre && pre.length > 0 && pre[0]) {
                    this.config.search.value.startDate = `${dayjs(pre[0]).format("YYYY-MM-DD")}`;
                    this.config.search.value.endDate = `${dayjs(pre[1]).format("YYYY-MM-DD")}`;
                    input(pre);
                  }
                }
              }
            });
          }
        }, {
          title: $t("cpv8dq4", "成功数量"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "sNumber",
          notShowForm: true,
          notShowSearch: true
        }, {
          title: $t("bu5qib4", "失败数量"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "fNumber",
          notShowForm: true,
          notShowSearch: true
        }, {
          title: $t("hkxb2", "操作"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "action",
          width: 130,
          notShowSearch: true,
          notShowForm: true,
          renderTable: (h, params) => {
            if (params.row.fNumber > 0) {
              return h("a", {
                "on": {
                  "click": () => this.downloadExecl(params.row)
                }
              }, [$t("h1riec6", "下载失败数据")]);
            } else {
              return;
            }
          }
        }]
      }
    };
  },
  methods: {
    close() {
      this.visible = false;
    },
    init() {
      this.visible = true;
      this.$refs.datePicker.handleClear();
    },
    downloadExecl(row) {
      exportExcel("get", `/api/file/failFileDownLoad?id=${row.id}`);
      console.log("row-----", row);
    },
    //手动搜索
    searchReset() {
      this.config.search.value.startDate = "";
      this.config.search.value.endDate = "";
      this.$refs.datePicker.handleClear();
      this.$refs["proTable"].fetch();
    }
  }
};